import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

import { CarrierChoice } from './getClaimContextCarrierQuery';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface GetClaimGroupCarrierQueryArgs {
  claimGroupId: string;
  handlingMode: string;
}

export const getClaimGroupCarrierRequest = ({
  claimGroupId,
  handlingMode,
}: GetClaimGroupCarrierQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/carriers?mode=${handlingMode}`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimGroupCarrierQuery = async (
  args: GetClaimGroupCarrierQueryArgs,
): Promise<BackResponse<CarrierChoice[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<CarrierChoice[]>>(
      getClaimGroupCarrierRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
